/**************************************************
 * Nombre:       Dialogo_Test
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import logo from '../../Recursos/logo_redondo.svg'
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import React, {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../App";
import {usePasosFormularios} from "../../Modulo_Pasos/Hooks/usePasosFormularios";
import Formulario_Pregunta_Test from "../Formularios/Formulario_Pregunta_Test";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {useNavigate} from "react-router";
import {arrRespuestasCalificadas} from "../../CodigoNegocio/Capacitaciones/arrRespuestasCalificadas";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";

const Dialogo_Test = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const navigate = useNavigate()
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: () => {
            navigate('/Capacitaciones')
        },
        funcionDos: cerrar
    })
    const [datosForms, setDatosForms] = useState({})
    const [preguntas, setPreguntas] = useState([])
    const [formulariosPreguntas, setFormulariosPreguntas] = useState([])
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: {}})
    const {Pasos} = usePasosFormularios({
        datos: datosForms, formularios: formulariosPreguntas, textoBoton: 'Enviar Respuestas'
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Enviando respuestas')
        console.log(entidad)

        let arrCalificaciones = arrRespuestasCalificadas({respuestas: entidad, preguntas: preguntas})

        let obj = {
            idUsuario: cData.usuario.id,
            idCapacitacion: datos.idCapacitacion,
            calificaciones: arrCalificaciones,
            id: datos.idCapacitacion,
            nombre: cData.usuario.nombre,
            correo: cData.usuario.correo,
            nombreCapacitacion: datos.nombre
        }

        console.log(obj)

        await guardarDoc('calificaciones', obj)

        terminar({aviso: 'Test Calificado, mira tu resultado en capacitaciones'})


    }

    const transformarContenidos = (arr) => {

        let arrConte = []
        for (let i = 0; i < arr.length; i++) {

            let pregunta = arr[i]

            let Conten = () => {
                return (
                    <Formulario_Pregunta_Test pregunta={pregunta} props={props} index={i}/>
                )
            }

            arrConte.push(Conten)
        }

        setFormulariosPreguntas(arrConte)

    }


    useEffect(() => {

        if (datos && datos.preguntas) {

            let preguntas = datos.preguntas
            setPreguntas(preguntas)
            transformarContenidos(preguntas)


        }

    }, [datos]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >


            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Pasos finalizar={subirDatos}/>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Test